(section_name => {
  // Progressive enhancement only — the page renders fully without JS.
  // Adds a gentle fade/rise reveal to each top-level block as it scrolls in.
  var root = document.querySelector('#acc_bf_lp_03 .acc-lp');
  if (!root || !('IntersectionObserver' in window)) return;

  // Only enable hidden initial state once JS is confirmed running.
  root.classList.add('acc-js');

  var blocks = root.querySelectorAll(':scope > *');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

  blocks.forEach(function (el) {
    el.classList.add('acc-reveal');
    io.observe(el);
  });

  root.addEventListener('click', function (e) {
    var link = e.target.closest('.acc-reason__cta');
    if (!link) return;
    e.preventDefault();
    var target = root.querySelector('.acc-cta.acc-wrap');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})("acc_bf_lp_03_01");
